export default __webpack_public_path__ + "static/media/registration-bg.3fc82dc0.jpeg";